
<template>
    <header class="page-header" aria-label="Logo">
        <div class="page-header__name">
            <a href="/">Chris Campbell</a>
        </div>
        <div class="page-header__role">
            Frontend Developer
        </div>
    </header>
</template>

<script>
export default {
    data() {
        return {

        };
    },
};
</script>

<style lang="scss">
    .page-header {
        margin-bottom: 3rem;

        @include mq($from: md) {
            margin-bottom: 6rem;
        }

        @include mq($from: lg) {
            margin-bottom: 8rem;
        }
    }

    .page-header__name {
        font-size: 3rem;
        font-weight: bold;
        line-height: 1;
        margin-bottom: 1rem;

        @include mq($from: md) {
            font-size: 4.5rem;
        }

        @include mq($from: lg) {
            font-size: 6rem;
            margin-bottom: 2rem;
        }

        a {
            text-decoration: none;
        }
    }

    .page-header__role {
        font-size: 2rem;
        font-weight: 100;
        line-height: 1;

        @include mq($from: md) {
            font-size: 2.4rem;
        }

        @include mq($from: lg) {
            font-size: 2.5rem;
        }
    }
</style>
